import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=527f4b54&"
import script from "@/views/Authed/Contact/Contact.js?vue&type=script&lang=js&"
export * from "@/views/Authed/Contact/Contact.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports